import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import Sidebar from "../../../components/Sidebar";
import TopBar from "../../../components/TopBar";
import "../index.css";
import download from "../../../../../assets/images/download-btn.png";
import { useDispatch } from "react-redux";
import { downloadSampleStudent } from "../../../api/Sample/Student/index";
import { uploadBulkStudent } from "../../../api/Upload/Student";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload, Modal } from "antd";
import { ToastContainer, toast } from "react-toastify";
import success from "../../../../../assets/images/success.png";
const { Dragger } = Upload;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function Index() {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [show, setShow] = useState(false);
  const [failed_count, setFailed_count] = useState(0);
  const [failedUrl, setFailedUrl] = useState("");
  const [fileList, setFileList] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  const downloadSample = async () => {
    try {
      const response = await fetch(
       `${API_BASE_URL}/sample/download?fileIdentifier=BULK_USER_SAMPLE_FILE`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ` + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch the file");
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = "BULK_UPLOAD_USER.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const uplaodFile = () => {
    if (file === null) {
    } else {
      let token = localStorage.getItem("token");
      let data = {
        token: "Bearer " + token,
        file: file,
      };
      dispatch(uploadBulkStudent(data)).then((res) => {
        console.log("res=====>", res);
        if (res.payload.status === "success") {
          setShow(true);

          setFailed_count(res.payload.message.payload.failure_count);
          if (res.payload.message.payload.total_count > 0) {
            setFailedUrl(res.payload.message.payload.failure_file_name);
          }
        } else if (res.payload.message.error === "invalid_token") {
          toast.error("Please login");
          window.location.href = "/";
        } else {
          // setFile(null);
          toast.error(res.payload.message.payload);
        }
      });
    }
  };
  const onChange = (info) => {
    const latestFileList = info.fileList.slice(-1);
    setFileList(latestFileList);
    setFile(info.file.originFileObj);
    if (latestFileList.length > 0) {
      const file = latestFileList[0];
      const originFile = file.originFileObj;
      setFile(originFile);
      if (originFile) {
        console.log("Native file object:", originFile);
        // You can now use `originFile` to read file content or upload manually
      }
    }
  };
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />
      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          <div className="flex items-center justify-between gap-3 bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm p-[24px]">
            <span className="text-base font-semibold text-[#171717] font-poppins">
              Download the template for bulk upload
            </span>
            <Button
              className="download-btn"
              onClick={() => downloadSample()}
              style={{ width: "40px", height: "40px", padding: 0, borderRadius: "12px", border: 0, background: "#EFF6FF" }}
            >
              <Image
                src={download}
                style={{ width: "24px", height: "24px" }}
              />
            </Button>
          </div>
          <div className="mt-3 bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm p-[24px] overflow-hidden">
            <Dragger
              accept=".xlsx"
              onChange={onChange}
              showUploadList={true}
              beforeUpload={() => false}
              multiple={false}
              fileList={fileList}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p className="ant-upload-hint">
                Support for a single or bulk upload. Strictly prohibited from
                uploading company data or other banned files.
              </p>
            </Dragger>
            {localStorage.getItem("role") === "ADMIN" ? (
              <Button className="submit-btn btn-gradient h-9 px-[14px] text-[13px] font-semibold" onClick={() => uplaodFile()}>
                Submit
              </Button>
            ) : null}
          </div>
        </div>
      </div>
      <ToastContainer />
      <Modal
        open={show}
        onCancel={() => setShow(!show)}
        footer={null}
        className="custom-modal text-center"
      >
        {failed_count > 0 ? null : (
          <Image
            src={success}
            style={{
              width: "45px",
              height: "45px",
              display: "inline-block",
            }}
          />
        )}

        <br></br>
        <br></br>
        {failed_count > 0 ? (
          <>
            <span className="success-text">
              <span style={{ color: "#4B61FF" }}>Ohh!!</span> There is some
              issue with file please check
            </span>
            <br></br>
            <Button
              href={failedUrl}
              target={"_blank"}
              rel={"noreferrer"}
              className="login-continue"
              style={{
                width: "50%",
              }}
            >
              View File
            </Button>
          </>
        ) : (
          <>
            <span className="success-text">
              <span style={{ color: "#4B61FF" }}>Congratulation!!</span> Student
              data uploaded please check
            </span>
            <br></br>
          </>
        )}

        <br></br>
        <br></br>
      </Modal>
    </div>
  );
}
